import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDF = async (elementRef, fileName = 'curriculo') => {
  if (!elementRef.current) {
    throw new Error('Elemento não encontrado');
  }

  try {
    const element = elementRef.current;
    
    // Tamanho A4 em pixels (96 DPI)
    const a4Width = 794;
    const a4Height = 1123;
    
    // Configurações para alta qualidade
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: a4Width,
      height: Math.max(element.scrollHeight, a4Height),
    });

    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    
    // Criar PDF em formato A4
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [a4Width, a4Height],
      hotfixes: ['px_scaling']
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    // Adicionar imagem ocupando toda a página
    pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

    // Gerar nome do arquivo baseado no nome do usuário
    const sanitizedFileName = fileName
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    pdf.save(`curriculo-${sanitizedFileName || 'meu-curriculo'}.pdf`);
    
    return true;
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
    throw error;
  }
};

export const formatPhoneNumber = (value) => {
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length <= 2) {
    return `(${numbers}`;
  } else if (numbers.length <= 7) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  } else if (numbers.length <= 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }
  
  return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validatePhone = (phone) => {
  const numbers = phone.replace(/\D/g, '');
  return numbers.length >= 10 && numbers.length <= 11;
};
